import css from 'styled-jsx/css';

export default css`
.fake-card-device {
  width: 100%;
  margin-bottom: 1rem;
  &--small {
    width: 33%;
    height: 1rem;
  }
  &--medium {
    width: 66%;
    height: 1rem;
  }
  &--full {
    width: 100%;
    height: 1rem;
  }
  &--image {
    width: 100%;
    height: 12rem;
  }
}

:global(.fake-card-device .card) {
  height: 369px;
}


@media (max-width: 1067px) {
  .fake-card-device {
    margin-bottom: 0rem;
    margin-left: 0rem;
  }

  :global(.fake-card-device .card) {
    height: 310px;
  }
}

`